import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;
const tree = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Wenn das Markup per Prerender-Script eingefügt wurde, mit hydrateRoot übernehmen
// (sonst createRoot, das den Inhalt ersetzt).
if (container.hasAttribute("data-prerendered") || container.childElementCount > 0) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
